import React from 'react';
import {caixa} from "../../data/caixa.json";

export function GastoMes() {
    return(
        <>
            <table>  
                <thead>
                    <tr>
                        <td>Gasto</td>
                        <td>Data</td>
                    </tr>
                </thead>

                <tbody>
                    {caixa.map(dados => {
                        return (
                            <tr>
                                <td>{dados.gastos}</td>
                                <td>{dados.date}</td>
                            </tr>
                        )
                    })}
                </tbody>
            </table> 
        </>
    );
};

export function LucroMes() {
    return(
        <>
        <table>
         
        <thead>
            <tr>
                 <td>Lucro</td>
                 <td>Data</td>
            </tr>
         </thead>

        <tbody>
                {caixa.map(dados => {
                return (

                    <tr>
                        <td>{dados.lucro}</td>
                        <td>{dados.date}</td>
                    </tr>
            )
            })}
        </tbody>

        </table> 
        </>
)};

export function ReceitaMes() {
    return(
        <>
        <table>
         
        <thead>
            <tr>
                 <td>Receita</td>
                 <td>Data</td>
            </tr>
         </thead>

        <tbody>
                {caixa.map(dados => {
                return (

                    <tr>
                        <td>{dados.receita}</td>
                        <td>{dados.date}</td>
                    </tr>
            )
            })}
        </tbody>

        </table> 
        </>
    )};
